import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { commonTypoStyles } from "@solveindustrial/Utilities/styleguide/FormFields/formField";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const dynamicDropdown = (): { defaultProps?: DynamicDropdownPresentationProps } => ({
    defaultProps: {
        cssOverrides: {
            list: css`
                ${commonTypoStyles}
                top: 30px;

                ${mediaQueriesBP.minMD} {
                    top: 50px;
                }
            `,
            selectedText: css`
                ${commonTypoStyles}
                padding: 0 35px 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                ${mediaQueriesBP.minMD} {
                    padding: 0 30px 0 10px;
                    line-height: 50px;
                }
            `,
            descriptionWrapper: css`
                ${mediaQueriesBP.minMD} {
                    position: absolute;
                }
            `,
        },
    },
});
